"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
const react_1 = require("react");
const components_1 = require("./../../../../components");
class Input extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            revealPassword: false,
        };
        this.renderRevealPasswordButton = () => {
            const { revealPassword } = this.state;
            return (React.createElement("button", { className: classNames('reveal-password-btn', { active: revealPassword }), type: "button", onClick: this.toggleRevealPassword },
                React.createElement(components_1.Icon, { name: "remove_red_eye" })));
        };
        this.toggleRevealPassword = () => this.setState({ revealPassword: !this.state.revealPassword });
    }
    render() {
        const _a = this.props, { showRevealPasswordButton, type } = _a, otherProps = __rest(_a, ["showRevealPasswordButton", "type"]);
        const { revealPassword } = this.state;
        const modifiedType = revealPassword ? 'text' : type;
        const hasNoErrors = this.props.state !== 'danger';
        return (type === 'text' ? (React.createElement(components_1.Input, Object.assign({ type: modifiedType, size: "lg" }, otherProps))) : type === 'password' ? (React.createElement("div", { className: "reveal-password-container" },
            React.createElement(components_1.Input, Object.assign({ type: modifiedType, size: "lg" }, otherProps)),
            hasNoErrors && this.renderRevealPasswordButton())) : null);
    }
}
exports.Input = Input;



//////////////////
// WEBPACK FOOTER
// ./src/demo/examples/FormExample/InputText/Input.tsx
// module id = 132
// module chunks = 0